<div placement="left" ngbTooltip="Report a bug!" class="bug-report-div">
  <button type="button" class="bug-report-button" (click)="toggleBugReportForm(bugReportDialog)">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="white" stroke-opacity="0.75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M9.09003 8.99999C9.32513 8.33166 9.78918 7.7681 10.4 7.40912C11.0108 7.05015 11.7289 6.91893 12.4272 7.0387C13.1255 7.15848 13.7588 7.52151 14.2151 8.06352C14.6714 8.60552 14.9211 9.29151 14.92 9.99999C14.92 12 11.92 13 11.92 13"
        stroke="white" stroke-opacity="0.75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 17H12.01" stroke="white" stroke-opacity="0.75" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>
</div>


<!-- <ng-template #bugReportDialog let-form="bugReportForm">HOLA</ng-template> -->

<ng-template #bugReportDialog let-form="bugReportForm">
  <div *ngIf="!bugReported" class="dialogWrapper">
    <div class="top">
      <div class="makeFlexRow text">
        <div class="icon-holder">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M1.81654 14C1.56098 14 1.37209 13.8889 1.24987 13.6667C1.12765 13.4444 1.12765 13.2222 1.24987 13L7.41654 2.33333C7.53876 2.11111 7.7332 2 7.99987 2C8.26654 2 8.46098 2.11111 8.5832 2.33333L14.7499 13C14.8721 13.2222 14.8721 13.4444 14.7499 13.6667C14.6276 13.8889 14.4388 14 14.1832 14H1.81654ZM7.99987 6.66667C7.81098 6.66667 7.65276 6.73044 7.5252 6.858C7.3972 6.986 7.3332 7.14444 7.3332 7.33333V9.33333C7.3332 9.52222 7.3972 9.68044 7.5252 9.808C7.65276 9.936 7.81098 10 7.99987 10C8.18876 10 8.3472 9.936 8.4752 9.808C8.60276 9.68044 8.66654 9.52222 8.66654 9.33333V7.33333C8.66654 7.14444 8.60276 6.986 8.4752 6.858C8.3472 6.73044 8.18876 6.66667 7.99987 6.66667ZM7.99987 12C8.18876 12 8.3472 11.936 8.4752 11.808C8.60276 11.6804 8.66654 11.5222 8.66654 11.3333C8.66654 11.1444 8.60276 10.9862 8.4752 10.8587C8.3472 10.7307 8.18876 10.6667 7.99987 10.6667C7.81098 10.6667 7.65276 10.7307 7.5252 10.8587C7.3972 10.9862 7.3332 11.1444 7.3332 11.3333C7.3332 11.5222 7.3972 11.6804 7.5252 11.808C7.65276 11.936 7.81098 12 7.99987 12ZM2.96654 12.6667H13.0332L7.99987 4L2.96654 12.6667Z"
              fill="#FDCF72" />
          </svg>
        </div>
        Report a bug
      </div>
      <div>
        <button mat-flat-button class="closeDialogButton" matDialogClose>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div class="filter-options">
      <form [formGroup]="bugReportForm">
        <fieldset>
          <div class="mb-3">
            <label for="email" class="form-label">Email <span class="red-star">*</span></label>
            <input type="email" class="form-control" id="email" formControlName="EmailId" placeholder="johndoe@xyz.com">
          </div>
          <div class="mb-3">
            <label for="title" class="form-label">Title<span class="red-star">*</span></label>
            <input type="text" class="form-control" id="title" formControlName="Title"
              placeholder="Please mention title of the bug">
            <div *ngIf="bugReportForm.get('Title').touched && bugReportForm.get('Title').invalid"><small
                class="text-danger">Title is requireed</small></div>
          </div>
          <div class="mb-3">
            <label for="desc" class="form-label">Description<span class="red-star">*</span></label>
            <textarea class="form-control" id="desc" formControlName="Description" rows="3"
              placeholder="Please describe the bug"></textarea>
            <div *ngIf="bugReportForm.get('Description').touched && bugReportForm.get('Description').invalid"><small
                class="text-danger">Description is requireed</small></div>
          </div>
          <div class="mb-3">
            <label class="f-12">Attach File</label>
            <div class="attach-file">
              <div>
                Drag and drop file or
                <span style="color: #91b5fd; text-decoration: underline; cursor: pointer" (click)="file.click()">Browse
                  computer</span>
              </div>
              <div (click)="file.click()" style="cursor: pointer;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                    stroke="#C6C7C9" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.3333 5.33333L7.99999 2L4.66666 5.33333" stroke="#C6C7C9" stroke-width="1.4"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 2V10" stroke="#C6C7C9" stroke-width="1.4" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <input #file class="select-file" type="file" (change)="onFileSelected(file.files)" />
            </div>
          </div>
          <div class="uploaded-file">{{ filename }}</div>
          <div class="mt-2">
            <label class="white-text f-12">How critical the bug is ? </label>
            <div class="radio-div" *ngFor="let ele of BugPriority; let i = index">
              <input name="criticalness" id="radio{{ i }}" type="radio" class="form-radio" [value]="ele"
                (change)="onPrioritySelect(ele)" />
              <div class="white-text-opacity f-14 p-2">{{ ele }}</div>
            </div>
          </div>
          <div *ngIf="submitted && !criticalNess">
            <small class="text-danger">
              Please select criticalness for this issue
            </small>
          </div>


          <div class="buttons">
            <button class="btn btn-dark" matDialogClose>
              Close
            </button>

            <button class="btn btn-primary f-12 p-1 ms-2" (click)="onSubmit()">
              Submit
            </button>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  <div *ngIf="bugReported" class="dialogWrapper" style="height: min-content !important;">
    <img src="../../assets/common-layout/report bug loader.gif">
    <!-- <iframe src="https://giphy.com/embed/3o7bu12GHm4G5frn6U" width="480" height="434" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/india-modi-dasnaiz-3o7bu12GHm4G5frn6U">via GIPHY</a></p> -->
  </div>
</ng-template>